import { urls } from './urls';
import { isInIframe } from './isInIframe';
import { addParamsToUrl } from '@zapier/url-utils';

// Only allow root-relative paths — blocks javascript:, data:, //evil.com, and external URLs.
function isSafeNextUrl(url: string | undefined): url is string {
  return (
    typeof url === 'string' && url.startsWith('/') && !url.startsWith('//')
  );
}

export function resolveSignUpNextUrl(
  nextUrl: string | undefined = undefined,
  params: Record<string, string | undefined> = {},
  context?: Record<string, any>
) {
  const safeNextUrl = isSafeNextUrl(nextUrl) ? nextUrl : undefined;

  if (isInIframe()) {
    return safeNextUrl || urls.IFRAME_DEFAULT_SIGNUP_NEXT;
  }
  // prevent app/onboarding to be appended twice
  if (safeNextUrl?.includes('onboarding')) {
    return safeNextUrl;
  }

  const nextQueryParams: Record<string, string | undefined> = {
    next: safeNextUrl,
    selected_apis: params.selected_apis,
    invitation_code: params.invitation_code,
    from: params.from,
  };

  let baseUrl = urls.DEFAULT_SIGNUP_NEXT;
  if (context?.skipOnboarding) {
    baseUrl = urls.REDIRECT_URL;
  }

  // add only truthy params
  return addParamsToUrl(baseUrl, nextQueryParams, true);
}
